import { PricingSection } from "@/components/marketing/PricingSection";
import { CTABanner } from "@/components/marketing/CTABanner";

const DESCRIPTION =
  "Free forever for your first three vehicles, plus Spotted, Meets RSVPs, and 5 AI document scans. Pro unlocks unlimited vehicles, photos, glovebox, unlimited AI scans, meet check-ins, and more — $6.99/mo or $59.99/yr.";

export function meta() {
  return [
    { title: "Pricing — RevHead Pro" },
    { name: "description", content: DESCRIPTION },
    { property: "og:title", content: "Pricing — RevHead Pro" },
    { property: "og:description", content: DESCRIPTION },
    { property: "og:url", content: "https://revhead.pro/pricing" },
    { tagName: "link", rel: "canonical", href: "https://revhead.pro/pricing" },
  ];
}

export default function Pricing() {
  return (
    <>
      <PricingSection />
      <CTABanner />
    </>
  );
}
